import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp24};
  border-radius: ${props => props.theme.primitives.radius.radius6};
`

export const OptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  vertical-align: middle;
`

export const ActionAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`
